/**
 * Curated merchant business-category list.
 *
 * The backend exposes a controlled `business_category` field (token) in
 * addition to the legacy free-text `category` field (label), which is still
 * `required` at registration. Screens that let a merchant pick a category
 * should present this list and derive both fields from the single selection
 * — see `businessCategoryLabel` below.
 */

export type TBusinessCategoryOption = {
    value: string;
    label: string;
};

export const businessCategories: TBusinessCategoryOption[] = [
    { value: 'retail_shopping', label: 'Retail & Shopping' },
    { value: 'food_drink', label: 'Food & Drink' },
    { value: 'health_wellness', label: 'Health & Wellness' },
    { value: 'beauty_personal_care', label: 'Beauty & Personal Care' },
    { value: 'professional_services', label: 'Professional Services' },
    { value: 'home_trades', label: 'Home & Trades' },
    { value: 'travel_hospitality', label: 'Travel & Hospitality' },
    { value: 'entertainment_events', label: 'Entertainment & Events' },
    { value: 'education', label: 'Education' },
    { value: 'igaming_operator', label: 'iGaming operator' },
    { value: 'digital_online', label: 'Digital & Online' },
    { value: 'non_profit_charity', label: 'Non-profit & Charity' },
    { value: 'other', label: 'Other' }
];

export const businessCategoryValues: string[] = businessCategories.map((item) => item.value);

/**
 * Resolve the curated label for a `business_category` token. Returns an empty
 * string for unknown or empty values so callers can safely fall back to the
 * legacy free-text `category` field.
 */
export const businessCategoryLabel = (value?: string): string => {
    if (!value) return '';
    return businessCategories.find((item) => item.value === value)?.label ?? '';
};
